<template>
  <div class="content alternate-bg">
    <div
      id="credits"
      class="scroll-head"
    />
    <el-row>
      <el-col>
        <h1 class="centre">
          <em>Credits</em>
        </h1>
      </el-col>
    </el-row>
    <el-row
      type="flex"
      justify="center"
    >
      <el-col
        :xs="22"
        :sm="18"
      >
        <p class="small centre">
          A number of frameworks/packages have been used to make this web site.
          Big thanks to the following:
          <br><br><br>
          <em>Lovely gradients</em>
          <br>
          <a
            target="_blank"
            href="https://sarcadass.github.io/granim.js/"
          >
            Granim.js</a>
          by
          <a
            target="_blank"
            href="https://twitter.com/Sarcadass"
          >
            Benjamin Blonde</a>
          <br><br>
          <em>Cool animated typing</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/mattboldt/typed.js/"
          >
            Typed.js</a>
          by
          <a
            target="_blank"
            href="https://mattboldt.com"
          >
            Matt Boldt</a>
          <br><br>
          <em>Code editor</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/surmon-china/vue-codemirror"
          >
            Vue-Codemirror</a>
          by
          <a
            target="_blank"
            href="https://github.com/surmon-china"
          >
            Surmon</a> and
          <a
            target="_blank"
            href="https://codemirror.net"
          >
            codemirror.net</a>
          <br><br>
          <em>Animations here & there</em>
          <br>
          <a
            target="_blank"
            href="https://animejs.com"
          >
            Anime.js</a>
          <br><br>
          <em>Smooth scrolling</em>
          <br>
          <a
            target="_blank"
            href="https://vue-scrollto.netlify.com"
          >
            vue-scrollto</a>
          by
          <a
            target="_blank"
            href="https://github.com/rigor789"
          >
            Igor Randjelovic</a>
          <br><br>
          <em>Image comparison component</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/mhayes/vue-twentytwenty"
          >
            vue-twentytwenty</a>
          by
          <a
            target="_blank"
            href="https://github.com/mhayes"
          >
            Mark Hayes</a>
          <br><br>
          <em>FAQ component</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/gerasimvol/vue-faq-accordion"
          >
            vue-faq-accordion</a>
          by
          <a
            target="_blank"
            href="https://github.com/gerasimvol"
          >
            Vladimir Gerasimenko</a>
          <br><br>
          <em>Thank-you-confetti</em>
          <br>
          <a
            target="_blank"
            href="https://www.npmjs.com/package/dom-confetti"
          >
            dom-confetti</a>
          by
          <a
            target="_blank"
            href="https://twitter.com/danielundin"
          >
            Daniel Lundin</a>
          <br><br>
          <em>CSS framework / component library</em>
          <br>
          <a
            target="_blank"
            href="https://element.eleme.io/#/en-US"
          >
            Element</a>
          <br><br>
          <em>Sharing component</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/nicolasbeauvais/vue-social-sharing"
          >
            vue-social-sharing</a>
          by
          <a
            target="_blank"
            href="https://github.com/nicolasbeauvais"
          >
            Nicolas Beauvais</a>
          <br><br>
          <em>Supporter tier medal design</em>
          <br>
          <a
            target="_blank"
            href="https://psdblast.com"
          >
            Andy (psdblast.com)</a>
          <br><br>
          <em>First-class apps for compressing images</em>
          <br>
          <a
            target="_blank"
            href="https://pngmini.com"
          >
            ImageAlpha</a>
          and
          <a
            target="_blank"
            href="https://imageoptim.com/mac"
          >
            ImageOptim</a>
          by (mostly)
          <a
            target="_blank"
            href="https://github.com/kornelski"
          >
            Kornel Lesinski</a>
          <br><br>
          <em>Article on lazily loading components when visible</em>
          <br>
          <a
            target="_blank"
            href="https://markus.oberlehner.net/blog/skeleton-loading-animation-with-vue/"
          >
            Skeleton Loading Animation with Vue.js</a>
          by
          <a
            target="_blank"
            href="https://markus.oberlehner.net"
          >
            Markus Oberlehner</a>
          <br><br>
          <em>Embed tweets in Vue apps</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/tonickkozlov/vue-tweet-embed"
          >
            vue-tweet-embed</a>
          by
          <a
            target="_blank"
            href="https://github.com/tonickkozlov"
          >
            Anton Kozlov
          </a>
          <br><br>
          <em>The nice JS framework</em>
          <br>
          <a
            target="_blank"
            href="https://vuejs.org"
          >
            Vue.js</a>
          <br><br>
          <em>Supercool scaffolding and tools for Vue.js development</em>
          <br>
          <a
            target="_blank"
            href="https://cli.vuejs.org"
          >
            Vue CLI</a>
          <br><br>
          <em>Automated building and deployment of web site from source</em>
          <br>
          <a
            target="_blank"
            href="https://travis-ci.org"
          >
            Travis CI</a>
          <br><br>
          <em>Very nice (and rather expensive) font design software</em>
          <br>
          <a
            target="_blank"
            href="https://glyphsapp.com"
          >
            Glyphs</a>
          <br><br>
          <em>Hosted by the nice folks at</em>
          <br>
          <a
            target="_blank"
            href="https://github.com/about"
          >
            GitHub</a>
          <br><br>
          <em>Font and web site</em>
          <br>
          <a
            target="_blank"
            href="mailto:victor.mono.font@gmail.com?subject=Thanks for making such a nice font"
          >
            Rune B</a>
        </p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'Credits'
}
</script>
